import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import './Policy.css';

const TermsConditions = () => {
  return (
    <div className="App">
      <Header />
      <div className="page policy-page">
        <div className="container">
          <div className="policy-header">
            <h1>Terms & Conditions</h1>
            <p className="policy-updated">Last Updated: January 2025 (Updated for HDFC Bank Smart Gateway Integration)</p>
          </div>

          <div className="policy-content">
            <section className="policy-section">
              <h2>1. Acceptance of Terms</h2>
              <div className="policy-text">
                <p>
                  By accessing and using the SLN BOOK WORLD website and services, you accept and agree 
                  to be bound by these Terms and Conditions. If you do not agree with any part of these 
                  terms, you must not use our services.
                </p>
                <p>
                  We reserve the right to modify these terms at any time. Your continued use of our 
                  services after changes are posted constitutes acceptance of the modified terms.
                </p>
              </div>
            </section>

            <section className="policy-section">
              <h2>2. Use of Website</h2>
              <div className="policy-text">
                <h3>2.1 Eligibility</h3>
                <ul>
                  <li>You must be at least 18 years old to use our services</li>
                  <li>You must provide accurate and complete information</li>
                  <li>You are responsible for maintaining the confidentiality of your account</li>
                  <li>You agree to notify us immediately of any unauthorized use</li>
                </ul>

                <h3>2.2 Prohibited Activities</h3>
                <p>You agree not to:</p>
                <ul>
                  <li>Use the website for any illegal or unauthorized purpose</li>
                  <li>Violate any laws in your jurisdiction</li>
                  <li>Transmit any viruses, malware, or harmful code</li>
                  <li>Attempt to gain unauthorized access to our systems</li>
                  <li>Interfere with or disrupt the website or servers</li>
                  <li>Copy, modify, or distribute website content without permission</li>
                  <li>Use automated systems to access the website</li>
                </ul>
              </div>
            </section>

            <section className="policy-section">
              <h2>3. Account Registration</h2>
              <div className="policy-text">
                <h3>3.1 Account Creation</h3>
                <ul>
                  <li>You must create an account to place orders</li>
                  <li>Provide accurate, current, and complete information</li>
                  <li>Maintain and update your information as necessary</li>
                  <li>You are responsible for all activities under your account</li>
                </ul>

                <h3>3.2 Account Security</h3>
                <ul>
                  <li>Keep your password secure and confidential</li>
                  <li>Notify us immediately of any security breach</li>
                  <li>We are not liable for losses due to unauthorized account access</li>
                  <li>We reserve the right to suspend or terminate accounts for violations</li>
                </ul>
              </div>
            </section>

            <section className="policy-section">
              <h2>4. Products and Pricing</h2>
              <div className="policy-text">
                <h3>4.1 Product Information</h3>
                <ul>
                  <li>We strive to provide accurate product descriptions and images</li>
                  <li>Product availability is subject to change</li>
                  <li>We reserve the right to limit quantities or refuse orders</li>
                  <li>Prices are subject to change without notice</li>
                </ul>

                <h3>4.2 Pricing</h3>
                <ul>
                  <li>All prices are in Indian Rupees (INR)</li>
                  <li>Prices include applicable taxes unless stated otherwise</li>
                  <li>Delivery charges are additional and displayed during checkout</li>
                  <li>We reserve the right to correct pricing errors</li>
                </ul>

                <h3>4.3 Payment</h3>
                <ul>
                  <li>Payment must be made at the time of order placement</li>
                  <li>We accept Credit/Debit Cards, UPI, and Net Banking through HDFC Bank Smart Gateway</li>
                  <li>All payments are processed securely through HDFC Bank Smart Gateway (PCI-DSS compliant)</li>
                  <li>Payment transactions are encrypted and secured using industry-standard security protocols</li>
                  <li>Orders are confirmed only after successful payment verification</li>
                  <li>You will be redirected to HDFC Bank's secure payment page to complete the transaction</li>
                </ul>
              </div>
            </section>

            <section className="policy-section">
              <h2>5. Orders and Delivery</h2>
              <div className="policy-text">
                <h3>5.1 Order Placement</h3>
                <ul>
                  <li>Placing an order constitutes an offer to purchase</li>
                  <li>We reserve the right to accept or reject any order</li>
                  <li>Order confirmation will be sent via email</li>
                  <li>We may cancel orders due to pricing errors or unavailability</li>
                </ul>

                <h3>5.2 Delivery</h3>
                <ul>
                  <li>Delivery timelines are estimates and not guarantees</li>
                  <li>Delivery charges vary based on location and delivery type</li>
                  <li>Risk of loss transfers to you upon delivery</li>
                  <li>You are responsible for providing accurate delivery address</li>
                </ul>
              </div>
            </section>

            <section className="policy-section">
              <h2>6. Returns and Refunds</h2>
              <div className="policy-text">
                <p>
                  Returns and refunds are governed by our Refund & Cancellation Policy. 
                  Please refer to that policy for detailed information about return eligibility, 
                  process, and refund timelines.
                </p>
              </div>
            </section>

            <section className="policy-section">
              <h2>7. Intellectual Property</h2>
              <div className="policy-text">
                <h3>7.1 Ownership</h3>
                <p>
                  All content on this website, including text, graphics, logos, images, and software, 
                  is the property of SLN BOOK WORLD or its content suppliers and is protected by 
                  copyright and trademark laws.
                </p>

                <h3>7.2 Limited License</h3>
                <p>
                  You are granted a limited, non-exclusive, non-transferable license to access and 
                  use the website for personal, non-commercial purposes. You may not reproduce, 
                  distribute, modify, or create derivative works without our written permission.
                </p>
              </div>
            </section>

            <section className="policy-section">
              <h2>8. Limitation of Liability</h2>
              <div className="policy-text">
                <h3>8.1 Disclaimer</h3>
                <p>
                  The website and services are provided "as is" without warranties of any kind, 
                  either express or implied. We do not guarantee that the website will be 
                  uninterrupted, secure, or error-free.
                </p>

                <h3>8.2 Limitation</h3>
                <p>
                  To the maximum extent permitted by law, SLN BOOK WORLD shall not be liable for 
                  any indirect, incidental, special, consequential, or punitive damages, including 
                  loss of profits, data, or use, arising from your use of the website or services.
                </p>

                <h3>8.3 Maximum Liability</h3>
                <p>
                  Our total liability for any claim shall not exceed the amount you paid for the 
                  specific product or service giving rise to the claim.
                </p>
              </div>
            </section>

            <section className="policy-section">
              <h2>9. Indemnification</h2>
              <div className="policy-text">
                <p>
                  You agree to indemnify and hold harmless SLN BOOK WORLD, its officers, directors, 
                  employees, and agents from any claims, damages, losses, liabilities, and expenses 
                  (including legal fees) arising from your use of the website, violation of these 
                  terms, or infringement of any rights of another party.
                </p>
              </div>
            </section>

            <section className="policy-section">
              <h2>10. Governing Law and Dispute Resolution</h2>
              <div className="policy-text">
                <h3>10.1 Governing Law</h3>
                <p>
                  These Terms and Conditions are governed by the laws of India. Any disputes shall 
                  be subject to the exclusive jurisdiction of the courts in Bengaluru, Karnataka.
                </p>

                <h3>10.2 Dispute Resolution</h3>
                <p>
                  In case of any dispute, we encourage you to first contact our customer support. 
                  If the dispute cannot be resolved amicably, it shall be resolved through arbitration 
                  in accordance with the Arbitration and Conciliation Act, 2015.
                </p>
              </div>
            </section>

            <section className="policy-section">
              <h2>11. Force Majeure</h2>
              <div className="policy-text">
                <p>
                  We shall not be liable for any failure or delay in performance due to circumstances 
                  beyond our reasonable control, including but not limited to natural disasters, 
                  pandemics, war, terrorism, labor strikes, or government actions.
                </p>
              </div>
            </section>

            <section className="policy-section">
              <h2>12. Severability</h2>
              <div className="policy-text">
                <p>
                  If any provision of these Terms and Conditions is found to be invalid or unenforceable, 
                  the remaining provisions shall continue in full force and effect.
                </p>
              </div>
            </section>

            <section className="policy-section">
              <h2>13. Contact Information</h2>
              <div className="policy-text">
                <p>
                  For questions about these Terms and Conditions, please contact us:
                </p>
                <ul>
                  <li><strong>Email:</strong> <a href="mailto:support@slnbooks.com">support@slnbooks.com</a></li>
                  <li><strong>Phone:</strong> <a href="tel:+919916832476">+91-9916832476</a>, <a href="tel:+919663622125">+91-9663622125</a></li>
                  <li><strong>Address:</strong> Ground Floor, 4 & 5, 6th Main Road, Dattatreya Nagar, Banashankari Stage 3, Bengaluru – 560085</li>
                </ul>
              </div>
            </section>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default TermsConditions;

